// extracted by mini-css-extract-plugin
export default {"loginForm":"styles_loginForm__23Ar6","form":"styles_form__rujAi","button":"styles_button__mUNc0","link":"styles_link__oeTPo"};